import React, { useEffect, useState } from "react";
import { FiX, FiCreditCard, FiSave } from "react-icons/fi";
import { processBalanceTransaction } from "./RepresentativeSettlementService";

const PAYMENT_METHODS = [
  {
    value: "كاش",
    label: "كاش",
  },
  {
    value: "انستا باي",
    label: "InstaPay",
  },
  {
    value: "فودافون كاش",
    label: "Vodafone Cash",
  },
];

const FinalPaymentModal = ({
  isOpen,
  onClose,
  selectedRepresentative,
  date,
  amount,
  transactionType,
  title,
  onSuccess,
}) => {
  const [paymentMethod, setPaymentMethod] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(0);

  useEffect(() => {
    if (isOpen) {
        setPaymentAmount(Number(amount) || 0);
        setPaymentMethod("");
        setNotes("");
        setLoading(false);
    }
    }, [isOpen, amount]);

  if (!isOpen) {
    return null;
  }

  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString("ar-EG");
  };

  const handleSubmit = async () => {
    if (!selectedRepresentative?.id) {
      return;
    }

    if (!paymentMethod) {
      alert("من فضلك اختر وسيلة الدفع");
      return;
    }

    if (!Number(paymentAmount) || Number(paymentAmount) <= 0) {
        alert("من فضلك أدخل مبلغ صحيح");
        return;
        }

    try {
      setLoading(true);

      await processBalanceTransaction({
        representativeId: selectedRepresentative.id,
        dailyDate: `${date}T00:00:00`,
        amount: Number(paymentAmount),
        paymentMethod,
        transactionType,
        notes,
      });

      if (onSuccess) {
        await onSuccess();
      }

      onClose();
    } catch (error) {
      console.error("Payment transaction error:", error);

      alert(
        error?.response?.data?.message ||
          error?.response?.data ||
          "حدث خطأ أثناء تنفيذ عملية الدفع"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="final-payment-modal-overlay">
      <div className="final-payment-modal">
        {/* Header */}
        <div className="final-payment-modal-header">
          <div className="final-payment-modal-title-wrapper">
            <div className="final-payment-modal-icon">
              <FiCreditCard size={18} />
            </div>

            <div>
              <h3>{title}</h3>

              <span>
                {transactionType === "صرف_للمندوب"
                  ? "صرف مبلغ للمندوب"
                  : "تحصيل مبلغ من المندوب"}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="final-payment-modal-close"
            onClick={onClose}
            disabled={loading}
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="final-payment-modal-body">
          {/* Amount */}
          <div className="final-payment-field">
            <label>المبلغ</label>

            <input
                type="number"
                min="0"
                value={paymentAmount}
                onChange={(event) =>
                setPaymentAmount(event.target.value)
                }
                placeholder="أدخل المبلغ"
                disabled={loading}
            />
            </div>

          {/* Payment Method */}
          <div className="final-payment-field">
            <label>وسيلة الدفع</label>

            <select
              value={paymentMethod}
              onChange={(event) =>
                setPaymentMethod(event.target.value)
              }
              disabled={loading}
            >
              <option value="">اختر وسيلة الدفع</option>

              {PAYMENT_METHODS.map((method) => (
                <option
                  key={method.value}
                  value={method.value}
                >
                  {method.label}
                </option>
              ))}
            </select>
          </div>

          {/* Notes */}
          <div className="final-payment-field">
            <label>ملاحظات</label>

            <textarea
              value={notes}
              onChange={(event) =>
                setNotes(event.target.value)
              }
              placeholder="اكتب ملاحظات العملية..."
              disabled={loading}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="final-payment-modal-footer">
          <button
            type="button"
            className="final-payment-cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            إلغاء
          </button>

          <button
            type="button"
            className="final-payment-submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            <FiSave size={16} />

            <span>
              {loading ? "جاري التنفيذ..." : "تأكيد الدفع"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalPaymentModal;